export const QMS_DOC_LIBRARY_ACCESS_REVOKED_MESSAGE =
  "You can no longer view this document. You are no longer part of the document library staff for this document.";
